export default "__VITE_ASSET__CdiSPi9O__"